module.exports = __webpack_public_path__ + "static/media/pka_background.fd141fb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/pka_background.png
// module id = 2658
// module chunks = 0